export function calculateAmount(rate: number, markup: number, markupType: string, quantity: number): number {
    return markupType === 'A' ? 
            (rate * quantity) + markup :
            rate * (1 + markup / 100) * quantity;
}